<div class="px-0 px-lg-5">
  <div class="content-page content-solutions">
    <div class="d-flex gap-lg-5 gap-0 flex-column flex-lg-row">
      <img [src]="solutionSelected?.image" alt="logo" class="w-100 h-auto img-banner">
      <div class="d-flex flex-column gap-xl-5 gap-3 content-left px-3 px-md-4 px-lg-2">
        <div>
          <h1 class="fs-2 fw-bold text-blue text-uppercase title-solution">{{ solutionSelected?.title }}</h1>
          <h2 class="fs-5 fw-semibold text-blue subtitle-solution">{{ solutionSelected?.subtitle }}</h2>
          <div class="content-solutions-description">
            <p class="fw-light text-blue mt-xl-5 mt-4 paragraph-solution">{{ solutionSelected?.description }}</p>
          </div>
        </div>
        <div class="d-flex gap-3 mt-xl-5 mt-0">
          <div class="d-flex flex-column gap-3">
            <div class="d-flex flex-column gap-3">
              <ng-container *ngFor="let bullet of solutionSelected?.bullets">
                <div class="d-flex align-items-center gap-3">
                  <img [src]="bullet.icon" alt="logo" width="24">
                  <span class="fw-light text-blue bullet-solution">{{ bullet.name }}</span>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="content-calculate d-flex flex-column gap-5 text-center align-items-center w-100" 
[class.justify-content-center]="!showLogo || isResponsive">
  <ng-container *ngIf="showLogo">
    <img src="assets/images/kaizen-logo.webp" alt="logo" width="166" class="mx-auto d-none d-lg-block pt-5">
    <div class="separator d-none d-lg-block"></div>
  </ng-container>
  <ng-container *ngIf="!showFormCalculate">
    <div class="d-flex flex-column align-items-center px-4 px-lg-0">
      <div class="d-none d-lg-block">
        <br><br>
      </div>
      <h1 class="text-blue fw-bold mb-4 fs-2 text-calculate">Calcula tu cobertura ideal</h1>
      <div class="content-solutions-calculate">
        <p class="text-blue fw-semibold fs-6">Calcula cuánta protección necesitan tus seres queridos para tener
          tranquilidad financiera incluso en tu ausencia.</p>
      </div>
      <div class="d-none d-block">
        <br><br><br>
      </div>
      <div class="btn-calculate mb-3 pointer d-flex align-items-center gap-3"
        (click)="showFormCalculate = !showFormCalculate">
        <span class="text-white">Calcular cobertura</span>
        <img src="assets/svg/icon-arrow-right-linear.svg" alt="logo" width="24">
      </div>
      <span class="timer fs-7">El cálculo tomará menos de 2 minutos.</span>
    </div>
  </ng-container>
  <ng-container *ngIf="showFormCalculate">
    <div class="px-4 px-xxl-5 w-100 pb-5">
      <app-form-protection (changeStepEvent)="showFormCalculate = !showFormCalculate" (hideLogoEvent)="showLogo = false"
      *ngIf="solutionSelected?.id === 1" class="w-100"></app-form-protection>
      <app-form-build (changeStepEvent)="showFormCalculate = !showFormCalculate" (hideLogoEvent)="showLogo = false"
        *ngIf="solutionSelected?.id === 2" class="w-100"></app-form-build>
      <app-form-management (changeStepEvent)="showFormCalculate = !showFormCalculate" (hideLogoEvent)="showLogo = false"
        *ngIf="solutionSelected?.id === 3" class="w-100"></app-form-management>
    </div>
  </ng-container>
</div>
<div class="px-4 px-xxl-5">
  <app-solutions-list [currentId]="solutionSelected?.id"
    (selectSolutionEvent)="selectSolution($event)"></app-solutions-list>
</div>
<div class="content-contact-us px-4 px-xxl-5">
  <app-contact-us></app-contact-us>
</div>